import {observable} from 'mobx';
import {createInstance, ModelProperties} from 'utils';
import {Language} from './language';

export class LanguageSync {
    @observable id!: number;

    @observable synced!: boolean;

    @observable languageId!: number;

    @observable language?: Language;

    constructor(status?: ModelProperties<LanguageSync>) {
        if (status) {
            Object.assign(this, status);
            this.language = createInstance(Language, status.language);
        }
    }
}